<template>
  <div>
    <!-- 头部 -->

    <Head></Head>
    <!-- 自营 -->
    <div class="main w">
      <div class="main-title">
        <h6>
          <span>{{ commodity.title_japanese }}</span> >
        </h6>
        <!-- 商家 -->
        <!-- <div class="merchant">
          <span>RAKUMART</span>
          <span> <img src="../../assets/img/kefu.png" alt />联系客服 </span>
          <span> <img src="../../assets/img/shoucang.png" alt />关注商家 </span>
        </div> -->
      </div>
      <!-- 商品信息 -->
      <div class="details">
        <!-- 商品图片 -->
        <div class="details-img fl">
          <div class="img-box" @click="img = !img">
            <!-- <pic-zoom
              url="https://img-blog.csdnimg.cn/20190506195523557.png?x-oss-process=image/watermark,type_ZmFuZ3poZW5naGVpdGk,shadow_10,text_aHR0cHM6Ly9ibG9nLmNzZG4ubmV0L3dlaXhpbl80NDI2ODQ3Mw==,size_16,color_FFFFFF,t_70"
              :scale="3"
            ></pic-zoom> -->
            <img :src="detailsimg" :class="{ img: img == true }" alt />
          </div>
          <ul>
            <li v-for="(item, index) in commodity.album" :key="index" @click="showImg(item)">
              <img :src="item" alt />
            </li>
          </ul>
          <div class="functional">
            <a href="javascript:;" class="enshrine" @click="favoriteAdd">
              お気に入り <i class="el-icon-star-off"></i></a>
            <button @click="downloadImg(2)" class="picbtn" :disabled="!show">
              画像ダウンロード
            </button>
            <!-- <a href="javascript:;">
              <img src="../../assets/img/guanzhu.png" alt /> 关注
            </a>
            <span>分享到:</span>
            <a href="javascript:;" class="share">
              <img src="../../assets/img/tb1.png" alt />
            </a>
            <a href="javascript:;" class="share">
              <img src="../../assets/img/tb2.png" alt />
            </a> -->
          </div>
        </div>
        <div class="details-select fl">
          <!-- 商品标题 -->
          <h3>
            {{
              commodity.title_japanese == ""
                ? commodity.title
                : commodity.title_japanese
            }}
          </h3>
          <p></p>
          <p style="color: #f3c622; margin-bottom: 20px">
            {{ commodity.title }}
          </p>
          <!--  商品单价 -->
          <div class="price">
            <span>単価</span>
            <div class="price-num">
              <ul>
                <li>
                  <span style="font-size: 20px; color: #f3c622">{{ price }}元</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 选择颜色 -->
          <div class="colour" v-if="flag == false">
            <span>カラー</span>
            <div class="colour-img fl">
              <ul>
                <li v-for="(item, index) in skuprops" :key="index" @click="getSize(index, item.url, item)"
                  v-bind:class="{ choose: index == ischoose }">
                  <img :src="item.url" alt />
                  <span>{{ item.color }}</span>
                </li>
              </ul>
              <button @click="downloadImg(1)" class="picbtn">
                画像ダウンロード
              </button>
            </div>
          </div>
          <!-- 选择颜色 -->
          <div class="size" v-else>
            <span>カラー</span>
            <ul>
              <li v-for="(item, index) in skuprops" :key="index" v-bind:class="{ choose: ischoose == index }"
                @click="getSize(index, item.imageUrl, item)">
                <a href="javascript:;">{{ item.color }}</a>
              </li>
            </ul>
          </div>
          <!-- 选择尺码 -->
          <div class="size" v-show="isshow != undefined">
            <span>サイズ</span>
            <ul>
              <li v-for="(item, index) in skusize" :key="index" v-bind:class="{ choose: index == ischoose1 }"
                @click="getInventory1(index, item)">
                <a href="javascript:;">{{ item.size }}</a>
              </li>
            </ul>
          </div>
          <!-- 数量 -->
          <div class="num">
            <span>在庫</span>
            <el-input-number v-model="num" :min="1" @blur="parseint" :disabled="isCheckClient"
              :max="inventory"></el-input-number>
            <em>在庫:{{ inventory }}</em>
          </div>
          <!-- 小计 -->
          <div class="subtotal">
            <span>小計</span>
            <em>{{ money }}元</em>
          </div>
          <!-- 购物车 购买 -->
          <div class="purchase">
            <!-- <button
              style="margin-left: 150px"
              v-if="
                userInfo &&
                userInfo.data.can_choose_product == 1 &&
                commodity.status != 10
              "
              @click="productAdd"
              :disabled="isCheckClient"
              :class="{ checkClient: isCheckClient }"
            >
              选购
            </button> -->

            <button @click="addCart" style="margin-left: 150px" v-if="commodity.status != 10" :disabled="isCheckClient"
              :class="{ checkClient: isCheckClient }">
              買い物かごへ追加
            </button>
            <button @click="addCart('注文')" style="margin-left: 30px" v-if="commodity.status != 10"
              :disabled="isCheckClient" :class="{ checkClient: isCheckClient }">
              注文
            </button>
            <button href="javascript:;" style="margin-left: 150px" v-else>
              已停售
            </button>
          </div>
        </div>
        <!-- 商品详情 -->
      </div>
      <div class="commodity-details">
        <!-- 店铺情报 -->
        <div class="store-details fl">
          <div class="store">
            <h4>店舗情報</h4>
            <div class="store-txt">
              <p>
                店舗名:
                <span>RAKUMART</span>
              </p>
              <p>
                店舗種類：:
                <span>RAKUMART</span>
              </p>
              <p>
                所在地：
                <span>中国 {{ commodity.delivery_address }}</span>
              </p>
            </div>
            <div>
              <router-link to="/">店铺</router-link>
              <router-link to="/">追加</router-link>
            </div>
          </div>
        </div>
        <!-- 商品详情 -->
        <div class="product-details fl">
          <div class="details-txt">
            <div class="details-title">
              <h3>商品详情</h3>
            </div>
            <ul class="detail_prop">
              <li v-for="(item, index) in commodity.detail_prop" :key="index">
                <strong>{{ item.k }}:</strong>
                <span>{{ item.v }}</span>
              </li>
            </ul>
          </div>
          <div class="details-img" v-html="commodity.detail_content" id="details-img"></div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <Foot></Foot>
  </div>
</template>
<script>
import Head from "../../components/head/Head";
import Foot from "../../components/foot/Foot";
import { mapState, mapMutations, mapActions } from "vuex";
import {
  getDetailsList,
  addCart,
  getDetailsList1688,
  favoriteAdd,
  productAdd,
  checkClient,
} from "../../api/API/details";
import JSZip from "jszip";
import FileSaver from "file-saver";
export default {
  data() {
    return {
      img: false,
      show: true,
      token: localStorage.getItem("token"),
      num: 1, // 数量
      money: "", // 小计
      commodity: [], // 获取得商品详情
      detailsimg: "", // 显示的图片
      inventory: "", // 库存
      skuprops: "", // 价格区间
      skusize: "", // 尺寸
      isshow: "", // 是否显示尺码
      ischoose: 0,
      ischoose1: 0,
      flag: true,
      price: 0,
      //   sign: false,
      // 加入购物车参数
      list: {
        product_item_id: this.$route.query.id,
        pic: this.detailsimg,
        color: "",
        size: "",
        num: 1,
        skuId: "",
        price: 0,
        title: "",
      },
      count: 60,
      isCheckClient: false, //true为违禁品
    };
  },
  components: {
    Head,
    Foot,
  },
  computed: {
    ...mapState(["cartCount", "userInfo"]),
  },
  created() {
    this.checkClient();
    this.getDetailsList();
  },
  methods: {
    ...mapActions(["getCart"]),
    checkClient() {
      let datas = { iid: this.$route.query.iid };
      checkClient(datas).then((res) => {
        if (res.code != 0) {
          this.isCheckClient = true;
          this.$confirm(res.data, "提示", {
            confirmButtonText: "確定",
            type: "warning",
            center: true,
          }).then(() => { });
        }
      });
    },
    // 获取得商品详情
    getDetailsList() {
      // 自营
      var list = {
        id: this.$route.query.id,
      };
      getDetailsList(list).then((res) => {
        console.log(res);
        if (res.code != 0) return;
        this.commodity = res.data;
        this.money = res.data.sku[0].size[0].pifa;
        this.detailsimg = res.data.image;
        this.list.title = res.data.title;
        this.list.pic = res.data.image;
        this.list.color = res.data.sku[0].color;
        this.list.skuId = res.data.sku[0].size[0].skuId;
        this.list.size = res.data.sku[0].size[0].size;
        this.list.price = this.money;
        this.skuprops = res.data.sku;
        this.skusize = res.data.sku[0].size;
        this.inventory = res.data.sku[0].size[0].num;
        this.price = res.data.sku[0].size[0].pifa;
        this.flag = res.data.sku.some((item) => item.url == "");
        if (this.inventory == 0) {
          this.isCheckClient = true;
        }
        console.log(this.flag);
      });
    },
    // 更改显示的图片
    showImg(url, index) {
      this.detailsimg = url;
    },
    // 获取库存
    getInventory(item) {
      this.inventory = item.size[this.ischoose1].num;

      if (this.inventory == 0) {
        this.isCheckClient = true;
      } else {
        this.isCheckClient = false;
      }
    },
    // 获取库存
    getInventory1(index, item) {
      this.ischoose1 = index;
      this.list.size = item.size;
      this.list.skuId = item.skuId;
      this.price = item.pifa;
      this.inventory = item.num;
      if (this.inventory == 0) {
        this.isCheckClient = true;
      } else {
        this.isCheckClient = false;
      }
    },
    // 显示图片，获取尺寸，获取库存
    getSize(index, url, item) {
      if (this.flag == false) {
        // 显示图片
        this.showImg(url);
        this.list.pic = url;
        this.ischoose = index;
      }
      this.list.color = item.color;
      this.getInventory(item);

      this.ischoose = index;
      this.skusize = item.size;
    },
    //  加入购物车
    addCart(type) {
      if (this.userInfo == null) {
        let url = this.$route.fullPath;
        this.toPage(url);
        this.$router.push("/login");
        return false;
      }

      let token = localStorage.getItem("token");
      addCart(token, this.list).then((res) => {
        if (res.code != 1) return this.$message.error("追加失敗しました");
        if (type == '注文') {
          let routeUrl = this.$router.resolve({
            path: "zhuwen?cid=" + res.data.join(','),
          });
          window.open(routeUrl.href, "_blank");
        } else {
          this.$message.success("買い物かごへ追加成功");

        }
        this.getCart();

      });
    },
    // 收藏商品
    favoriteAdd() {
      if (this.userInfo == null) {
        let url = this.$route.fullPath;
        this.toPage(url);
        this.$router.push("/login");
        return false;
      }
      let list = {
        iid: this.$route.query.id,
        pic: this.commodity.image,
        price: this.price,
        company: "RAKUMART",
        title: this.commodity.title,
        type: "RAKUMART",
        memberId: this.commodity.product_item_id,
        city: this.commodity.delivery_address,
      };
      console.log(list);
      favoriteAdd(this.token, list).then((res) => {
        if (res.code != 1) return this.$message.error(res.msg);
        this.$message.success("追加成功");
      });
    },
    parseint() {
      if (this.num >= this.inventory) {
        this.num = this.inventory;
      }
      if (this.num == undefined) {
        this.num = 1;
      }
      this.num = parseInt(this.num);
    },
    // 选购
    productAdd() {
      if (this.inventory <= 0) {
        return this.$message.error("库存不足");
      }
      let list = {
        user_id: 12,
        color: this.list.color,
        size: this.list.size,
        image: this.list.pic,
        id: this.list.skuId,
        title: this.commodity.title_japanese,
        stock: this.inventory,
        price: this.list.price,
      };
      productAdd(list).then((res) => {
        if (res.code == 1) this.$message.success("加购成功");
      });
    },

    downloadImg(i) {
      if (this.userInfo == null) {
        let url = this.$route.fullPath;
        this.toPage(url);
        this.$router.push("/login");
        return false;
      }
      let list = [];
      this.$message.success("ダウンロード中");
      if (i == 1) {
        this.skuprops.forEach((item, index) => {
          list[index] = {
            fileUrl: item.url,
            renameFileName: item.color + ".jpg",
          };
        });
      } else if (i == 2) {
        this.show = false;
        var timer = setInterval(() => {
          this.count -= 1;
          if (this.count <= 0) {
            this.show = true;
            this.count = 60;
            clearInterval(timer);
          }
        }, 1000);
        let imgList = document.querySelectorAll(".details-img p img");
        imgList.forEach((item, index) => {
          list[index] = {
            fileUrl: item.currentSrc,
            renameFileName: "img" + (index + 1) + ".jpg",
          };
        });
      }
      this.filesToRar(list, "画像ダウンロード");
    },
    filesToRar(arrImages, filename) {
      let _this = this;
      let zip = new JSZip();
      let cache = {};
      let promises = [];
      _this.title = "正在加载压缩文件";
      for (let item of arrImages) {
        const promise = _this.getImgArrayBuffer(item.fileUrl).then((data) => {
          // 下载文件, 并存成ArrayBuffer对象(blob)
          zip.file(item.renameFileName, data, { binary: true }); // 逐个添加文件
          cache[item.renameFileName] = data;
        });
        promises.push(promise);
      }
      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: "blob" }).then((content) => {
            _this.title = "正在压缩"; // 生成二进制流
            FileSaver.saveAs(content, filename); // 利用file-saver保存文件 自定义文件名
            _this.title = "压缩完成";
          });
        })
        .catch((res) => {
          _this.$message.error("文件压缩失败");
        });
    },
    //获取文件blob
    getImgArrayBuffer(url) {
      let _this = this;
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function () {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    },
    ...mapMutations(["outInfo", "toPage"]),
  },
  watch: {
    num() {
      if (this.num < 1) {
        this.num = 1;
      }
      this.list.num = this.num;
      this.money = (
        this.num * this.commodity.sku[this.ischoose].size[this.ischoose1].pifa
      ).toFixed(2);
    },
  },
};
</script>
<style lang='scss' scoped>
.main {
  overflow: hidden;
  font-size: 14px;

  .main-title {
    height: 30px;
    margin: 20px auto;
    line-height: 30px;
    background: #f2f2f2;

    h6 {
      width: 850px;
      float: left;
      font-size: 14px;
      margin-left: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .merchant {
      float: right;
      margin-right: 20px;

      span {
        // display: inline-block;
        // width: 200px;
        margin-left: 20px;
        // overflow: hidden;

        img {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 5px;
        }
      }
    }
  }

  .details {
    overflow: hidden;

    .details-img {
      margin-bottom: 74px;

      .img-box {
        position: relative;
        width: 460px;
        height: 460px;
        margin-bottom: 20px;
        cursor: pointer;

        img {
          position: absolute;
          width: 460px;
          height: 460px;
        }

        .img {
          transform: translate(300px, 0px);
          z-index: 99999;
          width: 690px;
          height: 690px;
          transition: all ease 1s;
        }
      }

      ul {
        overflow: hidden;
        margin-bottom: 20px;
        width: 460px;
        height: 125px;

        li {
          width: 107px;
          height: 125px;
          float: left;
          margin-right: 8px;
          background-color: pink;

          img {
            width: 107px;
            height: 125px;
          }
        }
      }

      .functional {
        a {
          color: #333;
          font-weight: 700;
        }

        .enshrine {
          border: 1px solid #ccc;
          margin-right: 20px;

          &:hover {
            color: #f3c622;
            border: 1px solid #f3c622;
          }
        }

        .share {
          img {
            width: 18px;
            height: 20px;
            vertical-align: middle;
            margin-left: 8px;
          }
        }

        span {
          margin-left: 10px;
        }
      }
    }

    .details-select {
      width: 793px;
      margin-left: 100px;
      font-weight: 700;
      color: #333;
      margin-bottom: 30px;

      h3 {
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 10px;
      }

      p {
        font-size: 12px;
        margin-bottom: 6px;
      }

      .price {
        overflow: hidden;
        margin-bottom: 15px;

        span {
          float: left;
          font-size: 14px;
          width: 100px;
        }

        ul {
          float: left;

          li {
            font-size: 24px;

            span {
              width: 100px;
            }
          }
        }
      }

      .distribution {
        font-size: 14px;
        margin-bottom: 20px;

        span {
          float: left;

          width: 80px;
        }
      }

      .colour {
        overflow: hidden;
        margin-bottom: 20px;

        span {
          float: left;
          width: 80px;
          font-size: 14px;
          line-height: 80px;
        }

        .colour-img {
          ul {
            width: 700px;

            li {
              float: left;
              position: relative;
              width: 80px;
              height: 80px;
              border: 2px solid transparent;
              margin-right: 10px;
              margin-bottom: 5px;

              &:hover span {
                display: block;
              }

              span {
                position: absolute;
                left: 0;
                top: 22px;
                text-align: center;
                color: #f3c622;
                display: none;
              }

              img {
                width: 80px;
                height: 80px;
              }
            }
          }
        }
      }

      .size {
        // height: 32px;
        margin-bottom: 15px;
        overflow: hidden;

        span {
          float: left;
          width: 80px;
          font-size: 14px;
          line-height: 32px;
        }

        ul {
          li {
            float: left;
            height: 30px;
            margin-right: 5px;
            border: 1px solid #ccc;
            margin-bottom: 3px;

            a {
              color: #333;
              font-size: 12px;
              line-height: 30px;
              padding: 0 10px;
            }
          }
        }
      }

      .num {
        margin-bottom: 20px;

        input {
          height: 26px;
          width: 20px;
          padding: 0 20px;
          border: 1px solid #ccc;
        }

        button {
          width: 30px;
          height: 30px;
          border: 1px solid #ccc;
          margin: 0 5px;
          cursor: pointer;
        }

        span {
          float: left;
          width: 80px;
          font-size: 14px;
          line-height: 32px;
        }

        em {
          margin-left: 20px;
        }
      }

      .subtotal {
        span {
          float: left;
          width: 80px;
          font-size: 14px;
          line-height: 32px;
        }

        em {
          color: #f3c622;
          font-size: 24px;
          font-weight: 700;
        }
      }

      .purchase {
        button {
          display: inline-block;
          height: 42px;
          line-height: 42px;
          font-size: 18px;
          font-weight: 700;
          background: #f3c622;
          color: #333;
          padding: 0 30px;
          border-radius: 5px;
          margin-left: 60px;
          cursor: pointer;
        }

        .checkClient {
          background-color: #eee;
          color: #fff;
          cursor: no-drop;
        }
      }
    }

    .picbtn {
      margin-top: 20px;
      padding: 10px;
      font-size: 16px;
      background: #f3c622;
      color: #fff;
    }
  }

  .commodity-details {
    color: #333;

    .store-details {
      width: 236px;
      border: 1px solid #ccc;

      .store {
        font-weight: 700;

        h4 {
          text-align: center;
          height: 40px;
          background: #f2f2f2;
          line-height: 40px;
          font-size: 16px;
          border-bottom: 1px solid #ccc;
        }

        .store-txt {
          padding: 20px;

          p {
            margin-bottom: 10px;
            font-size: 14px;
          }
        }

        a {
          display: block;
          height: 30px;
          padding: 0 10px;
          border: 1px solid #ccc;
          line-height: 30px;
          color: #333;
          font-size: 14px;
          text-align: center;
          width: 78px;
          margin: 0 auto 15px;
        }
      }
    }

    .product-details {
      width: 1150px;
      margin-left: 10px;

      .details-txt {
        border: 1px solid #ccc;

        .details-title {
          height: 40px;
          background: #f2f2f2;
          border-bottom: 1px solid #ccc;

          h3 {
            width: 120px;
            text-align: center;
            line-height: 40px;
            height: 40px;
            background: #f3c622;
            font-size: 16px;
            font-weight: 700;
          }
        }

        .detail_prop {
          overflow: hidden;
          padding: 40px;

          li {
            float: left;
            width: 240px;
            margin-bottom: 10px;
            font-size: 14px;
            font-weight: 500;

            span {
              margin-left: 20px;
            }
          }
        }
      }

      .details-img {
        margin: 30px auto;
        width: 800px;

        img {
          width: 800px;
        }

        ol {
          li {
            width: 800px;
            margin: 0 auto 20px;
            background: #f2f2f2;
          }
        }
      }
    }
  }
}

.choose {
  border: 2px solid #f3c622 !important;
  //   -webkit-border: 2px solid #F3C622 !important;
}

/deep/ .el-input-number__decrease {
  top: 2px;
}

/deep/ .el-input-number__increase {
  top: 2px;
}
</style>